import { clientApiCall } from "./apiCallWrapper";
import type {
  OrderStatuses,
  OrderSuccessData,
  PayLinkResponse,
  PersonalOrder,
} from "./types/orders";

const withCredentials = { withCredentials: true };

/** Клиентский API заказов Bitrix bxApi (/orders/*). */
export default (_axios: any, config: any) => ({
  getStatuses(): Promise<OrderStatuses | null> {
    return clientApiCall<OrderStatuses>(
      `${config.API_URL}/orders/getStatuses`,
      {
        api: "orders.getStatuses",
        axiosConfig: withCredentials,
      },
    );
  },

  getOrderSuccessPage(
    orderId: string | number,
  ): Promise<OrderSuccessData | null> {
    return clientApiCall<OrderSuccessData>(
      `${config.API_URL}/orders/getOrderSuccessPage`,
      {
        api: "orders.getOrderSuccessPage",
        // Страница «заказ оформлен» — сообщаем о любом сбое
        critical: true,
        params: { id: orderId },
        axiosConfig: withCredentials,
      },
    );
  },

  getPayLink(orderId: string | number): Promise<PayLinkResponse | null> {
    return clientApiCall<PayLinkResponse>(
      `${config.API_URL}/orders/getPayLink`,
      {
        api: "orders.getPayLink",
        critical: true,
        params: { id: orderId },
        axiosConfig: withCredentials,
      },
    );
  },

  getOrders(): Promise<PersonalOrder[] | null> {
    return clientApiCall<PersonalOrder[]>(
      `${config.API_URL}/orders/getOrders`,
      {
        api: "orders.getOrders",
        axiosConfig: withCredentials,
      },
    );
  },
});
